<template>
  <div class="Index2">
    <div class="l-container">
      <div class="wrapper">

        <div class="category">
          <div @click="regist" v-ripple>登録<i class="fa fa-fw fa-angle-down"></i></div>
          <div @click="list" v-ripple>リスト<i class="fa fa-fw fa-angle-down"></i></div>
          <div @click="support" v-ripple>対応履歴<i class="fa fa-fw fa-angle-down"></i></div>
          <div @click="pdf" v-ripple>PDF<i class="fa fa-fw fa-angle-down"></i></div>
          <div @click="keiri" v-ripple>経理<i class="fa fa-fw fa-angle-down"></i></div>
        </div>

        <div class="list">

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
            <a id="regist" href="http://153.126.169.95/users/sign_up"><i class="fa fa-fw fa-plus" title="User登録"></i>
              <span class="title">ユーザー登録</span>
              <span class="desc">ユーザー登録を行います。MGR以上の権限で登録可能</span>
            </a>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link id="regist" to="/appointments/add"><i class="fa fa-fw fa-plus" title="AP登録"></i>
              <span class="title">AP登録</span>
              <span class="desc">アポ登録画面です。家庭情報とは別です。契約にならなければ家庭登録はしません。</span>
            </router-link>

            <router-link id="regist" to="/families/add"><i class="fa fa-fw fa-plus" title="家庭登録"></i>
              <span class="title">家庭登録</span>
              <span class="desc">AP情報と紐付けて家庭情報を登録します。個別のAP詳細画面からでも登録できます。</span>
            </router-link>

            <router-link id="regist" to="/students/add"><i class="fa fa-fw fa-plus" title="生徒登録"></i>
              <span class="title">生徒登録</span>
              <span class="desc">家庭情報と紐付けて生徒情報を登録します。個別の家庭詳細画面からでも登録できます。</span>
            </router-link>

            <router-link id="regist" to="/tutors/add"><i class="fa fa-fw fa-plus" title="先生登録"></i>
              <span class="title">先生登録</span>
              <span class="desc">先生の登録画面です。</span>
            </router-link>

            <router-link id="regist" to="/agreements/add"><i class="fa fa-fw fa-plus" title="契約情報登録"></i>
              <span class="title">契約情報登録</span>
              <span class="desc">契約情報の登録画面です。契約情報は家庭ではなく生徒ごとに登録します。</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
            <router-link id="list" to="/users"><i class="fa fa-fw fa-list-ul" title="ユーザーリスト"></i>
              <span class="title">ユーザーリスト</span>
              <span class="desc">NEOの登録ユーザー一覧です。MGR以上の権限で閲覧可能</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
            <router-link id="list" to="/advisors"><i class="fa fa-fw fa-list-ul" title="アドバイザー"></i>
              <span class="title">アドバイザー</span>
              <span class="desc">アドバイザーの一覧です。</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link id="list" to="/appointments"><i class="fa fa-fw fa-list-ul" title="APリスト"></i>
              <span class="title">APリスト</span>
              <span class="desc">アポの一覧です。契約前の家庭はここで管理します。</span>
            </router-link>

            <router-link id="list" to="/appointments/confirms"><i class="fa fa-fw fa-list-ul" title="確認リスト"></i>
              <span class="title">確認リスト</span>
              <span class="desc">前日確認用リストです。</span>
            </router-link>

            <router-link id="list" to="/families"><i class="fa fa-fw fa-list-ul" title="家庭リスト"></i>
              <span class="title">家庭リスト</span>
              <span class="desc">家庭の一覧です。契約前の家庭はここにはありません。</span>
            </router-link>

            <router-link id="list" to="/students"><i class="fa fa-fw fa-list-ul" title="生徒リスト"></i>
              <span class="title">生徒リスト</span>
              <span class="desc">生徒の一覧です。対応履歴は家庭と生徒で共有されます。</span>
            </router-link>

            <router-link id="list" to="/tutors"><i class="fa fa-fw fa-list-ul" title="先生リスト"></i>
              <span class="title">先生リスト</span>
              <span class="desc">先生の一覧です。探しをする為のレイアウトになっています。</span>
            </router-link>

            <router-link id="list" to="/agreements"><i class="fa fa-fw fa-list-ul" title="契約リスト"></i>
              <span class="title">契約リスト</span>
              <span class="desc">契約の一覧です。生徒の詳細からも閲覧、編集できます。</span>
            </router-link>

            <router-link id="list" to="/students/inheritance"><i class="fa fa-fw fa-list-ul" title="引継リスト"></i>
              <span class="title">引継リスト</span>
              <span class="desc">引継リストです。</span>
            </router-link>

            <router-link id="list" to="/tutor_channels"><i class="fa fa-fw fa-list-ul" title="tutor_channels"></i>
              <span class="title">家庭教師登録媒体リスト</span>
              <span class="desc">家庭教師が登録された媒体の一覧です。重複も含めて一覧にしています。</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link id="support" to="/appointmentsupports"><i class="fa fa-fw fa-phone" title="AP対応履歴"></i>
              <span class="title">AP対応履歴</span>
              <span class="desc">AP対応履歴の一覧です。</span>
            </router-link>

            <router-link id="support" to="/familysupports"><i class="fa fa-fw fa-phone" title="家庭対応履歴"></i>
              <span class="title">家庭対応履歴</span>
              <span class="desc">家庭対応履歴の一覧です。</span>
            </router-link>

            <router-link id="support" to="/tutorsupports"><i class="fa fa-fw fa-phone" title="先生対応履歴"></i>
              <span class="title">先生対応履歴</span>
              <span class="desc">先生対応履歴の一覧です。</span>
            </router-link>

            <router-link to="/tags"><i class="fa fa-fw fa-tags" title="タグリスト"></i>
              <span class="title">タグリスト</span>
              <span class="desc">対応履歴に紐づけるタグの管理画面です。タグを削除すると対応履歴のタグも削除されます。</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link id="pdf" to="/familyfiles"><i class="fa fa-fw fa-file-pdf-o" title="家庭ファイル"></i>
              <span class="title">家庭ファイル</span>
              <span class="desc">契約書、口座振替依頼書、などの家庭に関するPDFの一覧です。</span>
            </router-link>

            <router-link id="pdf" to="/studentfiles"><i class="fa fa-fw fa-file-pdf-o" title="生徒ファイル"></i>
              <span class="title">生徒ファイル</span>
              <span class="desc">生徒に関するPDFの一覧です。報告書ページができるまでここで報告書を管理します。</span>
            </router-link>

            <router-link id="pdf" to="/tutorfiles"><i class="fa fa-fw fa-file-pdf-o" title="先生ファイル"></i>
              <span class="title">先生ファイル</span>
              <span class="desc">履歴書、研修資料、などの先生に関するPDFの一覧です。</span>
            </router-link>

            <a id="pdf" href="http://153.126.169.95/student_tutors/search?limit=30" target="_blank"><i class="fa fa-fw fa-file-pdf-o" title="報告書管理"></i>
              <span class="title">報告書管理</span>
              <span class="desc">別タブで開きます</span>
            </a>
          </template>

          <template v-if="user.type === 'admin'">
            <!-- <router&#45;link to="/reports"><i class="fa fa&#45;fw fa&#45;file&#45;pdf&#45;o" title="報告書"></i> -->
            <router-link id="pdf" to="/reports"><i class="fa fa-fw fa-exclamation-triangle" title="報告書"></i>
              <span class="title">報告書</span>
              <span class="desc">メンテナンス中</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <a href="http://153.126.169.95/student_tutors/?limit=30" target="_blank"><i class="fa fa-fw fa-file-pdf-o" title="指導情報"></i>
              <span class="title">指導情報</span>
              <span class="desc">生徒先生の紐付けです</span>
            </a>
          </template>

          <template v-if="user.office === '仙台'">
            <a href="/kenshus"><i class="fa fa-fw fa-leanpub" title="スケジュール"></i>
              <span class="title">スケジュール</span>
              <span class="desc">面接、研修の予定を管理します。</span>
            </a>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link to="/student_tutors"><i class="fa fa-fw fa-file-text" title="探しデータ"></i>
              <span class="title">探しデータ</span>
              <span class="desc">探しの管理画面です。</span>
            </router-link>

          </template>

          <template v-if="user.type === 'admin'">
            <router-link to="/events"><i class="fa fa-fw fa-file-text" title="イベントリスト"></i>
              <span class="title">イベントリスト</span>
              <span class="desc">Todoに紐づけるイベントの管理画面です。</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin'">
            <router-link to="/todos"><i class="fa fa-fw fa-check-square" title="Todoリスト"></i>
              <span class="title">Todoリスト</span>
              <span class="desc">個人Todo、探しTodo、すべてのTodoが表示されます。</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
            <a id="keiri" href="/contracts"><i class="fa fa-fw fa-money" title="経理"></i>
              <span class="title">経理</span>
              <span class="desc">経理管理画面です。ADMIN / OWNER / ACT</span>
            </a>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'mgr'">
            <router-link to="/aggregates/appointments"><i class="fa fa-fw fa-line-chart" title="集計-AP"></i>
              <span class="title">集計-AP</span>
              <span class="desc">アポの集計画面です。ADMIN / OWNER / ACT / MGR</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner'">
            <router-link to="/aggregates/contracts"><i class="fa fa-fw fa-line-chart" title="集計-売上"></i>
              <span>集計-売上</span>
              <p class="desc">売上の集計画面です。<br>ADMIN / OWNER</p>
            </router-link>

            <router-link to="/aggregates/paymentdetails"><i class="fa fa-fw fa-line-chart" title="集計-自社割賦"></i>
              <span>集計-自社割賦</span>
              <p class="desc">自社割賦の集計画面です。<br>ADMIN / OWNER</p>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr' || user.type === 'staff' || user.type === 'act'">
            <router-link to="/aggregates/tutor_channels"><i class="fa fa-fw fa-line-chart" title="集計-家庭教師"></i>
              <span class="title">集計-家庭教師</span>
              <span class="desc">家庭教師の集計画面です。</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
            <router-link to="/contracts"><i class="fa fa-fw fa-exclamation-triangle" title="appointment_channels"></i>
              <span class="title">契約情報</span>
              <span class="desc">ADMIN / OWNER / ACT</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
            <router-link to="/paymentdetails"><i class="fa fa-fw fa-exclamation-triangle" title="appointment_channels"></i>
              <span class="title">テキスト支払</span>
              <span class="desc">ADMIN / OWNER / ACT</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
            <router-link to="/paymentdetails2s"><i class="fa fa-fw fa-exclamation-triangle" title="appointment_channels"></i>
              <span class="title">管理費支払</span>
              <span class="desc">ADMIN / OWNER / ACT</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin'">
            <router-link to="/channels"><i class="fa fa-fw fa-graduation-cap" title="channels"></i>
              <span class="title">家庭教師登録媒体</span>
              <span class="desc">ADMIN媒体を管理する画面です。</span>
            </router-link>
          </template>

          <template v-if="user.type === 'admin'">
            <router-link to="/appointment_channels"><i class="fa fa-fw fa-exclamation-triangle" title="appointment_channels"></i>
              <span class="title">appointment_channels</span>
              <span class="desc">メンテナンス中</span>
            </router-link>
          </template>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dtp: Object
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  methods: {
    regist () {
      document.getElementById('regist').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },
    list () {
      document.getElementById('list').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },
    support () {
      document.getElementById('support').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },
    pdf () {
      document.getElementById('pdf').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },
    keiri () {
      document.getElementById('keiri').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  },
  route: {
  },
  mounted () {
  }
}
</script>

<style lang="scss">
.Index2 {
}
</style>
<style lang="scss" scoped>
.wrapper {
  .category {
    margin-top: 5px;
    display: flex;
    div {
      position: relative;
      // display: table;
      font-size: 14px;
      font-weight: bold;
      background: #36474f;
      color: #fff;
      text-align: center;
      border-radius: 25px;
      padding: .75em;
      margin: 5px;
      width: 130px;
      box-shadow: 0 2px 2px rgba(0,0,0,.24), 0 0 2px rgba(0,0,0,.12);
      text-decoration: none;
      transition: all .3s;
      &:hover {
        box-shadow: 0 4px 4px rgba(1,67,163,.24), 0 0 4px rgba(1,67,163,.12), 0 6px 18px rgba(43,133,231,.12);
        cursor: pointer;
        transform: translate3d(0,-2px,0);
      }
      i {
        positon: absolute;
        top: 11px;
        right: 10px;
        margin-left: 5px;
        position: absolute;
        font-size: 16px;
      }
      .title {
        color: #3ab981;
        // color: #039be5;
        font-weight: bold;
      }
      .desc {
        padding: 0 0 0 5px;
        font-size: 11px;
        line-height: 1.5;
      }
    }
  }
  .list {
    margin-top: 5px;
    overflow: auto;
    height: calc(100vh - 150px);
    a {
      display: table;
      font-size: 14px;
      color: #637d88;
      margin: 5px;
      width: calc(100% - 10px);
      border-radius: 25px;
      box-shadow: 0 2px 2px rgba(0,0,0,.24), 0 0 2px rgba(0,0,0,.12);
      text-decoration: none;
      padding: 10px;
      transition: all .3s;
      &:hover {
        box-shadow: 0 4px 4px rgba(1,67,163,.24), 0 0 4px rgba(1,67,163,.12), 0 6px 18px rgba(43,133,231,.12);
        cursor: pointer;
        transform: translate3d(0,-2px,0);
      }
      i {
        color: #039be5;
        // color: #3ab981;
        margin-right: 5px;
        font-size: 14px;
      }
      .title {
        color: #3ab981;
        // color: #039be5;
        font-weight: bold;
      }
      .desc {
        padding: 0 0 0 5px;
        font-size: 11px;
        line-height: 1.5;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Index2.vue?1dbc33bb